import React from "react";
import { Team } from '../entities/site'

interface CampaignInterface {
  templates: [];
  chosenTemplate: string;
  name: string;
  type: string;
  weekDays: number[];
  branches: Team[];
  teams: object;
  split: boolean;
  nameOnCard: string;
  submitted: boolean;
}

const campaignInitial: CampaignInterface = {
  templates: [],
  chosenTemplate: "",
  weekDays: [],
  type: "Restaurant",
  name: "",
  branches: [],
  teams: [],
  split: false,
  nameOnCard: "",
  submitted: false
};

export default campaignInitial;



// WEBPACK FOOTER //
// ./src/store/initialState.tsx